import { SharedState } from '@trello/shared-state';

export type MonitorStatus = 'idle' | 'active';
export const monitorStatus = new SharedState<MonitorStatus>('idle');
